import { CSSProperties, FC } from "react";

import { IRideTableDto } from "@ryde/shared";

import { CardBoardDroppableWrapper } from "./card-board-droppable-wrapper";
import { CardBoardItem } from "./card-board-item";
import { CardBoardRowStyled } from "./card-board-row.styled";

interface ICardBoardRowProps {
  style: CSSProperties;
  rides: IRideTableDto[];
  columnCount: number;
  index: number;
}

export const CardBoardRow: FC<ICardBoardRowProps> = ({
  index,
  style,
  rides,
  columnCount,
}) => {
  const startIndex = index * columnCount;

  return (
    <CardBoardRowStyled style={style} $columnCount={columnCount}>
      {rides.map((item, idx) => (
        <CardBoardDroppableWrapper rideDto={item} key={startIndex + idx}>
          <CardBoardItem rideDto={item} />
        </CardBoardDroppableWrapper>
      ))}
    </CardBoardRowStyled>
  );
};
